import { Button } from "@/ui-components/ui/button";
import { Home } from "lucide-react";

/**
 * StaticErrorHeader - A minimal header for error pages
 *
 * This header is used on error pages (404, 500) and doesn't depend on:
 * - Router context (uses window.location instead)
 * - Auth context (no user menu)
 * - Search functionality
 *
 * This ensures error pages can render even when the app's context providers
 * or router fail, since the ErrorBoundary wraps the entire app in main.tsx
 */
export function StaticErrorHeader() {
  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <header className="sticky top-0 z-[60] bg-card/90 backdrop-blur-sm border-b border-border">
      <div className="flex flex-col">
        <div className="relative h-[64px] flex items-center justify-between px-6">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="inline-flex items-center">
              <img
                src="/specstorylogo.svg"
                alt="SpecStory"
                className="h-6 w-auto hover:scale-105 transition-transform"
              />
            </a>
          </div>

          {/* Home button */}
          <Button
            onClick={handleGoHome}
            variant="ghost"
            size="sm"
            className="flex items-center gap-2 text-muted-foreground hover:text-foreground"
          >
            <Home className="w-4 h-4" />
            <span className="hidden sm:inline">Home</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
